import React, {Component, PropTypes} from 'react';

// Wahve Apply start JS pixel
const BASE_PIXEL_URL= '//jotrack.s3.amazonaws.com/pzn0/';

// Map pixels to conversionType parameter
const PIXEL_MAP =
  [
    { id: 'preliminary-application', pixel: 'job-apply-start.js' },
    { id: 'preliminary-qualified', pixel: 'job-apply.js'},
    { id: 'preliminary-unqualified', pixel: 'job-conversion1.js'},
    { id: 'preliminary-dropoff', pixel: 'job-conversion2.js'},
    { id: 'full-apply', pixel: 'job-conversion3.js'},
    { id: '', pixel: undefined}
  ];

class JoveoTrackingPixel extends Component {
  static propTypes = {
    conversionType: PropTypes.string,
    trackingURL: PropTypes.string
  }

  constructor(props, context) {
    super(props, context);
    const pixel = PIXEL_MAP.find((p) => p.id === this.props.conversionType);
    const url = pixel.pixel ? BASE_PIXEL_URL.concat(pixel.pixel) : undefined;

    this.state = {
      trackingURL: url,
    };
  }

  componentDidMount () {
//  Joveo Tracking Pixel
      if (this.state.trackingURL) {
        this.appendScript(this.state.trackingURL);
      }
  }

  componentWillUnmount () {
//  Joveo Tracking Pixel
    if (this.state.trackingURL) {
      this.removeScript(this.state.trackingURL);
    }
  }

  // dynamically add script to component
  appendScript = (scriptToAppend) => {
    const script = document.createElement('script');
    script.src = scriptToAppend;
    script.async = true;
    document.body.appendChild(script);
  }

  // dynamically remove script to component
  removeScript = (scriptToRemove) => {
    const allsuspects=document.getElementsByTagName('script');
    for (let i=allsuspects.length; i>=0; i--) {
      if (allsuspects[i] && allsuspects[i].getAttribute('src')!==null
        && allsuspects[i].getAttribute('src').indexOf(`${scriptToRemove}`) !== -1) {
        allsuspects[i].parentNode.removeChild(allsuspects[i]);
      }
    }
  }

  render() {
    return (
      <div>
        <div ref={(el) => (this.instance = el)} />
    </div>
    );
  }
}

export default JoveoTrackingPixel;




// WEBPACK FOOTER //
// ./shared/react/f_PreliminaryApplication/f_Application/r_ApplicationForm/r_CreateUserModal/JoveoTrackingPixel/index.js